exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ":host{display:flex;flex-direction:column;font-family:Open Sans}:host .explication{background-color:#bbd6f5}:host .avertissement-header{font-size:17px;font-weight:600;line-height:2rem}:host .avertissement-header,:host .explication{font-family:Open Sans}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/sass-loader/lib/loader.js!./~/sass-resources-loader/lib/loader.js?{"resources":["./~/bootstrap/scss/_functions.scss","./~/bootstrap/scss/_variables.scss","./src/main/webapp/content/scss/variables.scss"]}!./src/main/webapp/app/depot-requete/steps/juridiction/type-acte-attaque-section/type-acte-attaque-info/type-acte-attaque-info.component.scss
// module id = 670
// module chunks = 0